module.exports = __webpack_public_path__ + "img/security-top-image.3f28c658.svg";